import {ApiClient} from '@hconnect/apiclient'
import {HttpError} from '@hconnect/common'
import {useQuery} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {createRetryFunction} from '../../../../shared/helpers/queryHelpers'
import {DistributedCacheResponse, QueryOptionsType} from '../../../../shared/types/common.types'

export const QueryKey = 'userStorageQuery'

export const useGetUserStorage = <TData = DistributedCacheResponse,>({
  keyIdentifier,
  options
}: {
  keyIdentifier: string
  options?: QueryOptionsType<DistributedCacheResponse, AxiosError<HttpError>, TData>
}) => {
  return useQuery<DistributedCacheResponse, AxiosError<HttpError>, TData>({
    queryKey: [QueryKey, keyIdentifier],
    queryFn: async () => {
      const path = '/distributeduserstorage'
      return (
        await ApiClient.axiosInstance.get<DistributedCacheResponse>(path, {
          params: {
            keyIdentifier
          }
        })
      ).data
    },
    // these default values will get moved to the api provider soon
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    throwOnError: (_, query) => query.state.data === undefined,
    retry: createRetryFunction(3),
    retryDelay: 1000 * 3,
    ...options
  })
}
